const DEV_FILE_PATTERNS_US = [
  /^https:\/\/storage\.googleapis\.com\/vrcam-dev-5a815-images/,
  /^https:\/\/cdn-dev\.istaging\.com/,
  /^https:\/\/vrcam-dev-cdn\.istaging\.com/,
  /^https:\/\/storage-dev\.istaging\.com/
]
const DEV_FILE_REPLACEMENT_EU = 'https://vrmaker-dev.istaging.com'
const PROD_FILE_PATTERNS_US = [
  /^https:\/\/storage\.googleapis\.com\/vr-cam-161603-images/,
  /^https:\/\/cdn\.istaging\.com/,
  /^https:\/\/vrcam-prod-cdn\.istaging\.com/,
  /^https:\/\/image\.istaging\.com/
]
const PROD_FILE_REPLACEMENT_EU = 'https://vrmaker.istaging.com'
const DEV_US_BUCKET_NAME = 'vrcam-dev-5a815-images'
const DEV_EU_BUCKET_NAME = 'vrmaker-dev'
const PROD_US_BUCKET_NAME = 'vr-cam-161603-images'
const PROD_EU_BUCKET_NAME = 'vrmaker'
// US -> EU migration 期間，由於 Firebase 檔案儲存的還是 US 連結，
// 因此要將連結改為 EU CDN URL，或是更改檔案 Bucket name
export const getEUFileUrl = (url) => {
  if (!url) return url
  let newUrl = url
  for (const pattern of DEV_FILE_PATTERNS_US) {
    if (pattern.test(newUrl)) {
      newUrl = newUrl.replace(pattern, DEV_FILE_REPLACEMENT_EU)
      break
    }
  }
  for (const pattern of PROD_FILE_PATTERNS_US) {
    if (pattern.test(newUrl)) {
      newUrl = newUrl.replace(pattern, PROD_FILE_REPLACEMENT_EU)
      break
    }
  }
  newUrl = newUrl
    .replace(DEV_US_BUCKET_NAME, DEV_EU_BUCKET_NAME)
    .replace(PROD_US_BUCKET_NAME, PROD_EU_BUCKET_NAME)
  return newUrl
}
export const recursionReplaceUrl = (data) => {
  if (data == null) return data
  // 處理字串 - 檢查是否為 URL
  if (typeof data === 'string') {
    if (data.match(/^https?:\/\//i)) {
      return getEUFileUrl(data)
    }
    return data
  }
  // 處理陣列
  if (Array.isArray(data)) {
    return data.map(item => recursionReplaceUrl(item))
  }
  // 處理物件
  if (typeof data === 'object') {
    const newObj = {}
    for (const [key, value] of Object.entries(data)) {
      newObj[key] = recursionReplaceUrl(value)
    }
    return newObj
  }
  // 其他型別直接返回
  return data
}
